/** 常用正则表达式 */

// 是否是手机号
export function isPhone (val) {
    var pattern = /^1\d{10}$/;
    return pattern.test(val);
}

// 是否是手机号
export function isEmail (val) {
    var pattern = /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-\_\-]+)+$/;
    return pattern.test(val);
}

// 姓名
export function isName (val) {
    var pattern = /^[\u4e00-\u9fa5]{2,10}$|^[\w+\s]{1,20}$/;
    return pattern.test(val);
}

// 邮编
export function isZip (val) {
    var pattern = /^[0-9]\d{5}$/;
    return pattern.test(val);
}

// 身份证
export function issfz (val) {
    var pattern = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
    return pattern.test(val);
}

// 数字
export function isNum (val) {
    var pattern = /([1-9]\d*\.?\d*)|(0\.\d*[1-9])/;
    return pattern.test(val);
}

// 数字或字母组合
export function isNumOrStr (val) {
    var pattern = /^[A-Za-z0-9]+$/;
    return pattern.test(val);
}

// 匹配中英文
export function isChAndEn (val) {
    var pattern = /[a-zA-Z\u4e00-\u9fa5]+/g;
    return !pattern.test(val);
}

// 匹配拼音
export function isNameSpell (val) {
    var pattern = /^([a-z]+(\s){1})([a-z]+)$/g;
    return pattern.test(val);
}
// 是否正整数
export function isPositiveInteger (val) {
    var pattern = /^([1-9][0-9]*)$/;
    return pattern.test(val);
}
// 是否座机号
export function isLandline (val) {
    var pattern = /^((\d{7,8})|(\d{4}|\d{3})-(\d{7,8})|(\d{4}|\d{3})-(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1})|(\d{7,8})-(\d{4}|\d{3}|\d{2}|\d{1}))$/;
    return pattern.test(val);
}
